<template>
  <v-card>
    <v-toolbar color="secondary" class="elevation-0">
      <v-toolbar-title> Quota Aggregate </v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        disable-pagination
        disable-sort
        dense
        hide-default-footer
      >
        <template v-slot:[`item.details`]="{ item }">
          <v-btn icon @click="showDetails(item)">
            <v-icon>mdi-clipboard-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="detailsDialog" width="500">
      <v-card>
        <v-toolbar color="secondary" class="elevation-0">
          <v-toolbar-title>
            {{ this.item?.code }}
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="detailsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5 px-5">
          <pre class="text-body-1">{{
            JSON.stringify(this.item?.details, null, 2)
          }}</pre>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import client from "@/lib/ApiClient";
import { capitalise } from "@/lib/utils";

export default {
  props: ["tenant_uid"],
  data: () => ({
    loading: false,
    detailsDialog: false,
    item: null,
    headers: [
      { text: "Code", value: "code" },
      { text: "Issued", value: "issued" },
      { text: "Outstanding", value: "outstanding" },
      { text: "Used", value: "used" },
      // { text: "Refunded", value: "refunded" },
      // { text: "Manually Added", value: "manuallyAdded" },
      { text: "Expiring Next Cycle", value: "expiring" },
      { text: "Details", value: "details" },
    ],
    tenantQuotaAggregate: null,
  }),

  watch: {
    detailDialog(val) {
      if (!val) this.item = null;
    },

    subscriptions(val, prevVal) {
      if (prevVal === null && val) 
        this.fetchTenantQuotaAggregate()
    }
  },

  computed: {
    ...mapGetters(["quotaAggregate", "subscriptions"]),
    items() {
      const quotaAggregate = this.tenant_uid
        ? this.tenantQuotaAggregate
        : this.quotaAggregate;

      if (!quotaAggregate) return [];

      return Object.entries(quotaAggregate)?.map(([quota_code, a]) => ({
        code: capitalise(quota_code),
        issued: a.issued,
        outstanding: a.outstanding,
        used: a.used,
        refunded: a.refunded,
        manuallyAdded: a.manuallyAdded,
        expiring: a.expiring["1"] || 0,
        details: a,
      }));
    },
  },

  methods: {
    showDetails(item) {
      this.item = item;
      this.detailsDialog = true;
    },
    async fetchTenantQuotaAggregate() {
      const activeSubscription = this.subscriptions?.filter(s => s.tenant_uid === this.tenant_uid).some(s => ["active", "pending"].includes(s.subscription_status))
      if (!activeSubscription) return
      this.tenantQuotaAggregate =
        await client.gateway.management.fetchTenantQuotaAggregate(
          this.tenant_uid
        );
    },
  },

  beforeMount() {
    if (this.tenant_uid && this.subscriptions) this.fetchTenantQuotaAggregate();
  },
};
</script>
